import { MengeListEntry } from './MengeListEntry';
import { MengeTableCell } from './MengeTableCell';

const MengeEntry = {
    List: MengeListEntry,
    Cell: MengeTableCell,
};

export { MengeEntry };
